import { IconGenerationCasual } from 'src/assets/icons/longForm/IconGenerationCasual';
import { IconGuidanceBoost } from 'src/assets/icons/longForm/IconGuidanceBoost';
import { IconGuidanceExpand } from 'src/assets/icons/longForm/IconGuidanceExpand';
import { IconGuidanceInstructions } from 'src/assets/icons/longForm/IconGuidanceInstructions';
import { IconGuidanceShorten } from 'src/assets/icons/longForm/IconGuidanceShorten';
import { IconGuidanceTov } from 'src/assets/icons/longForm/IconGuidanceTov';
import { GENERATION_IMPROVE_MODE } from 'src/data/generation';

const ICONS = {
  [GENERATION_IMPROVE_MODE.improveEngaging]: IconGuidanceInstructions,
  [GENERATION_IMPROVE_MODE.improveSimilar]: IconGuidanceInstructions,
  [GENERATION_IMPROVE_MODE.boostScoreEngaging]: IconGuidanceBoost,
  [GENERATION_IMPROVE_MODE.boostScoreSimilar]: IconGuidanceBoost,
  [GENERATION_IMPROVE_MODE.makeCasual]: IconGenerationCasual,
  [GENERATION_IMPROVE_MODE.makeLonger]: IconGuidanceExpand,
  [GENERATION_IMPROVE_MODE.makeShorter]: IconGuidanceShorten,
  [GENERATION_IMPROVE_MODE.changeTov]: IconGuidanceTov,
};

export const getIcon = (action) => ICONS[action] || null;
